import React from "react";

const Progress = () => {
  return (
    <div>
      <div className="flex flex-col bg-white dark:bg-slate-900/50 gap-2 p-4 m-1 rounded-md h-auto  shadow-lg">
        <div className="">
          <div className="font-bold text-indigo-950 dark:text-slate-400">
            Formation status
          </div>
          <div className="text-xs font-bold text-indigo-500 dark:text-slate-400">
            In progress
          </div>
        </div>
        <div class="h-4 w-full  dark:bg-gray-200 rounded-lg">
          <div class="h-4 bg-indigo-900 dark:text-slate-400 w-[30%] rounded-lg"></div>
        </div>
        <div className="flex flex-col items-center">
          <div className="font-bold text-indigo-950 dark:text-slate-400">
            Estimated Processing
          </div>
          <div className="font-semibold text-indigo-900 dark:text-slate-400 text-sm">
            4-5 business days
          </div>
        </div>
        <div>
          <button className="bg-gradient-to-tr from-pink-900 to-indigo-900 dark:text-slate-400 p-4 text-white w-full rounded-xl">
            View Status
          </button>
        </div>
      </div>
    </div>
  );
};

export default Progress;
